import Vue from "vue";
import conceptTransformer from "@/transformers/purchase/lifting/concepts";

/**
 * @author Jose Luis R
 * @param concepts Onl to change quantity
 * @return {Object}
 */

const updateConcepts = (payload) => {
  return Vue.$http.put(`purchase/concept/detail/`, { concepts: conceptTransformer.sendCollection(payload) })
}


export default updateConcepts;



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/updateConcepts.js